module.exports = __webpack_public_path__ + "img/pg- intellect.5ec4febb.jpg";